import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "enumTranslation" })
export class EnumTranslationPipe implements PipeTransform {
   public transform(
      value: string,
      prefix?: string,
      underscoreCast: boolean = false
   ): string {
      return value
         ? `${prefix ? `${prefix}_` : ""}${this.underscoreCast(
              value,
              underscoreCast
           )}`
         : "";
   }

   private underscoreCast(
      value: string,
      underscoreCast: boolean = false
   ): string {
      return underscoreCast
         ? value
              .replace(
                 /(?:^|\.?)([A-Z])/g,
                 (_: any, y: string) => "_" + y.toLowerCase()
              )
              .replace(/^_/, "")
         : value;
   }
}
